export const LOCALE = 'nb-NO';
export const CURRENCY = 'NOK';
export const CURRENCY_DISPLAY = 'code';
//# sourceMappingURL=defaults.js.map